// The Benchmark section's queries: who the user is to it, the case lists per tab, and editors' progress.

import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { goldenService } from '@/services/golden.service';
import type { GoldenTab } from '@/types/golden.types';

export const GOLDEN_QUERY_KEY = ['sentinel', 'golden'] as const;

export const goldenMeQueryAtom = atomWithQuery(() => ({
  queryKey: [...GOLDEN_QUERY_KEY, 'me'],
  queryFn: goldenService.me,
  staleTime: 5 * 60_000,
  retry: false,
}));

const hasAccessAtom = atom((get) => {
  const role = get(goldenMeQueryAtom).data?.role;
  return role === 'sentinel' || role === 'editor';
});

const casesQuery = (tab: GoldenTab, enabled: boolean) => ({
  queryKey: [...GOLDEN_QUERY_KEY, 'cases', tab],
  queryFn: () => goldenService.listCases(tab),
  enabled,
  retry: false,
});

/** To do lists these first, each with Continue. */
export const benchmarkInProgressQueryAtom = atomWithQuery((get) => casesQuery('in_progress', get(hasAccessAtom)));

export const benchmarkDoneQueryAtom = atomWithQuery((get) => casesQuery('done', get(hasAccessAtom)));

/** The To do list in its fixed per-Sentinel order: the badge, Start next, Next case and "Case n of N to do". */
export const benchmarkTodoQueryAtom = atomWithQuery((get) => casesQuery('todo', get(hasAccessAtom)));

export const benchmarkProgressQueryAtom = atomWithQuery((get) => ({
  queryKey: [...GOLDEN_QUERY_KEY, 'progress'],
  queryFn: goldenService.progress,
  enabled: get(goldenMeQueryAtom).data?.role === 'editor',
  retry: false,
}));
